import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthFlow } from '@/hooks/account/useAuthFlow.ts';
import { useAuth } from '@/api';
import { LoginForm, ResetPasswordForm, ResetSuccessForm } from '@/components/features/account/login';
import { LoginLayout } from '@/components/layout';
import { useAppSelector } from '@/hooks';


const Login: React.FC = () => {
  const { isAuthenticated, user } = useAuth();
  const accountLinkRequired = useAppSelector((state) => state.auth.accountLinkRequired);
  const {
    currentView,
    resetFormData,
    isResetting,
    resetError,
    navigateToReset,
    navigateToLogin,
    handleResetEmailChange,
    handleResetSubmit,
  } = useAuthFlow();

  if (isAuthenticated && user && !accountLinkRequired) {
    return <Navigate to="/" replace />;
  }

  const handleNeedHelp = () => {
    // Aquí se podría abrir un modal de ayuda o redirigir
  };

  const renderContent = () => {
    switch (currentView) {
      case 'login':
        return (
          <LoginForm 
            onForgotPassword={navigateToReset}
            onNeedHelp={handleNeedHelp}
          />
        );
        
      case 'reset-password':
        return (
          <ResetPasswordForm
            email={resetFormData.email}
            error={resetError}
            isLoading={isResetting}
            onEmailChange={handleResetEmailChange}
            onSubmit={handleResetSubmit}
            onBackToLogin={navigateToLogin}
          />
        );
        
      case 'reset-success':
        return (
          <ResetSuccessForm
            email={resetFormData.email}
            onBackToLogin={navigateToLogin}
          />
        );
        
      default:
        return null;
    }
  };

  const getTitleForCurrentView = () => {
    switch (currentView) {
      case 'login':
        return '¡Bienvenido a Rex asistencia!';
      case 'reset-password':
        return '¿No recuerdas tu contraseña?';
      case 'reset-success':
        return '¡Estás a un paso de ingresar!';
      default:
        return '¡Bienvenido a Rex asistencia!';
    }
  };

  const getDescriptionForCurrentView = () => {
    switch (currentView) {
      case 'reset-password':
        return 'Ingresa tu nombre de usuario y te enviaremos un correo electrónico con las instrucciones a la dirección email registrada previamente en el sistema.';
      default:
        return undefined;
    }
  };

  return (
    <LoginLayout 
      title={getTitleForCurrentView()}
      description={getDescriptionForCurrentView()}
    >
      {renderContent()}
    </LoginLayout>
  );
};

export default Login;
